import {ChangeDetectorRef, Component, OnInit}     from "@angular/core";
import {AuthState, onAuthUIStateChange}           from "@aws-amplify/ui-components";
import {SessionService}                           from "./services/session.service";
import {Router}                                   from "@angular/router";
import {MenuController, Platform}                 from "@ionic/angular";
import {Auth}                                     from "aws-amplify";
import {BonusStatus, BonusType, CreateBonusInput} from "./API.service";
import {DateTime}                                 from "luxon";
import {SplashScreen}                             from "@capacitor/splash-screen";
import {environment}                              from "src/environments/environment";
import OneSignal                                  from 'onesignal-cordova-plugin';
import {menuController}                           from "@ionic/core";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
    public dataLoaded: boolean = false;

    constructor(
            private ref: ChangeDetectorRef,
            public sessionService: SessionService,
            private platform: Platform,
            private router: Router,
    ) {

    }

    OneSignalInit(): void {
        this.platform.ready().then(plateform => {
            OneSignal.initialize(environment.onSignal.id);



        });

    }

    async ngOnInit() {
        this.OneSignalInit();


        try {
            let user = await Auth.currentAuthenticatedUser();
            await this.sessionService.setNewAuthState(user, AuthState.SignedIn);
        } catch (e) {
            this.sessionService.setNewAuthState(null, AuthState.SignedOut);
        }
    }

    ngOnDestroy() {
        return onAuthUIStateChange;
    }

    initializeApp() {

        this.platform.ready().then(() => {
            this.sessionService.theme = localStorage.getItem("theme") || "";
            if (this.sessionService.authState === AuthState.SignedIn) {
                
                //this.router.navigate(['/home']);
            } else {
                
                //    this.router.navigate(['/home']);
            }
        });
    }

    onBookmarkClick(url) {
        this.router.navigate([`${url}`]);
    }

    removeBookmark(url) {
        let allBookmarks = JSON.parse(localStorage.getItem("bookmarks")) || [];
        let newBookmarks = allBookmarks.filter((a) => {
            return a.url != `${url}`;
        });
        localStorage.setItem("bookmarks", JSON.stringify(newBookmarks));
    }

    async closeMenu() {
        await menuController.toggle()
    }
}
